/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const graph_increase_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M.75 23.25h1.5m21 0h-1.5M3.432 9.241 19.5 1.944M16.319.75l3.18 1.194-1.193 3.181M2.25 23.25V18a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v5.25m-4.5 0h4.5m0 0h3m0 0V13.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v9.75m-4.5 0h4.5m0 0h3m0 0V10.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v12.75m-4.5 0h4.5"
    />
  </svg>
)
export default graph_increase_medium
